<div *ngIf="showProgress" class="progress-container">
  <div class="progress" [style.width]="progress + '%'"></div>
</div>
